import {
    FETCH_USERUNINSTALL_REQUEST,
    FETCH_USERUNINSTALL_SUCCESS,
    FETCH_USERUNINSTALL_FAILURE,
    SEARCH_USERUNINSTALL_REQUEST,
    SEARCH_USERUNINSTALL_SUCCESS,
    SEARCH_USERUNINSTALL_FAILURE
  } from "./uninstallAction";
  
  const initialState = {
    loading: false,
    userUninstallData: [],
    searchResults: [],
    error: "",
  };
  
  const userUninstallReducer = (state = initialState, action) => {
      switch (action.type) {
        case FETCH_USERUNINSTALL_REQUEST:
          return {
            ...state,
            loading: false,
          };
        case FETCH_USERUNINSTALL_SUCCESS:
          return {
            loading: false,
            userUninstallData:  [...state.userUninstallData, ...action.payload],
            error: '',
          };
        case FETCH_USERUNINSTALL_FAILURE:
          return {
            loading: false,
            userUninstallData: [],
            error: action.payload,
          };
          case SEARCH_USERUNINSTALL_REQUEST:
            return {
              ...state,
              loading: false,
            };
          case SEARCH_USERUNINSTALL_SUCCESS:
            return {
              ...state,
              loading: false,
              searchResults: action.payload,
              error: '',
            };
          case SEARCH_USERUNINSTALL_FAILURE:
            return {
              ...state,
              loading: false,
              error: action.payload,
            };
        default:
          return state;
      }
    };
  
  
    export default userUninstallReducer;